module.exports = __webpack_public_path__ + "static/img/41.b65dba3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/qq/41.gif
// module id = kKDT
// module chunks = 0